/**
 * @flow
 * @format
 */

import { createSelector } from 'reselect';
import _ from 'lodash';

import { StepOrder } from '~/utils/stepHelpers';

export const isLoading = (state: AppStateType): boolean => state.design.loading;
const designData = (state: AppStateType): Object => state.design;
const currentStep = (state: AppStateType): string => state.design.currentStep;
const stepStatus = (state: AppStateType): Object => state.design.stepStatus;
const initialValues = (state: AppStateType): Object =>
  state.design.initialValues;
const allValues = (state: AppStateType): Object => state.design.values;
export const getSchematic = (state: AppStateType): Object =>
  state.design.schematic;
export const getReportPDF = (state: AppStateType): Object =>
  state.design.report;

export function nextStep(step: string): string {
  const index = StepOrder.findIndex(i => i === step);
  if (index === StepOrder.length - 1) return StepOrder[index];
  return StepOrder[(index + 1) % StepOrder.length];
}

export function prevStep(step: string): string {
  const index = StepOrder.findIndex(i => i === step);
  if (index === 0) return StepOrder[index];
  // index = index === 0 ? StepOrder.length : index;
  return StepOrder[(index - 1) % StepOrder.length];
}

export const getCurrentStep = createSelector(
  [currentStep],
  (step: string) => step,
);

export const getNextStep = createSelector([currentStep], (step: string) =>
  nextStep(step),
);

export const getPrevStep = createSelector([currentStep], (step: string) =>
  prevStep(step),
);

export const getAllData = createSelector([designData, isLoading], data => data);

export const getFieldValues = createSelector([getAllData], data => data.values);

export const getChangedFields = createSelector(
  [getAllData],
  data => data.changedFields,
);

export const getFieldErrors = createSelector([getAllData], data => data.errors);

export const getFieldWarnings = createSelector([getAllData], data => data.info);

export const getDirtyFields = createSelector(
  [getAllData],
  data => data.dirtyFields,
);

export const getEvaluatingFields = createSelector(
  [getAllData],
  data => data.evaluating,
);

export const getValuesForEval = createSelector(
  [getFieldValues, getChangedFields],
  (values, changedValues) => _.pick(values, Object.keys(changedValues)),
);

export const getName = createSelector([designData], data => data.name);

export const getStepStatus = createSelector([stepStatus], data => data);

export const getSnubberStatus = createSelector([allValues], values =>
  _.get(values, ['Snub_sel', 'currentValue']),
);

export const getResetStatus = createSelector(
  [getCurrentStep, allValues, initialValues, isLoading],
  (step, vals, initialVals) => !_.isEqual(vals, initialVals),
);



// WEBPACK FOOTER //
// ./src/selectors/design.js